/* eslint-disable no-useless-escape */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useRef, useState } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { LicenseManager } from "ag-grid-enterprise";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import "./GridContainer.css";
import { useSelector, useDispatch } from "react-redux";
import _ from "underscore";
import ICHValueCellRenderer from "./ICHValueRenderer";
import APP_CONST from "../../../shared/constants";
import { StorageHelper } from "../../../../../utils/storageHelper";
import * as documentActions from "../.././../../store/actions/documentActions";
import * as zoneActions from "../.././../../store/actions/zoneActions";
import { useLocation } from "react-router-dom";
import DocumentStatus from "./DocumentStatus";
import { useTranslation } from "react-i18next";

const GridContainer = (props) => {
  const {
    onDownloadIconClick,
    setIsDocViewVisible,
    documentDetailsHandler,
    deletePopup,
  } = props;
  const gridRef = useRef();
  const location = useLocation();
  const { t } = useTranslation();

  let {
    dropdownChange,
    dropdownChangeFilter,
    selectedValue,
    setSelectedValue,
    setDropDownChanged,
    setDropDownChangedFilter,
    tempCustomizedColState,
    setTempCustomizedColState,
    tempCustomizedFilterState,
    setTempCustomizedFilterState,
    tempDefaultColState,
    setTempDefaultColState,
    tempDefaultFilterState,
    setTempDefaultFilterState,
    currentMode,
    setCurrentMode,
    fileCount,
    setFileCount,
    isFilterHappend,
    setIsFilterHappend,
    getAgResultCount,
    isCustomizedChanged,
    isDefaultChanged,
    isGridReset,
    setIsGridReset,
    setAgFilterValue,
    onDropDownValuesChange,
    closeMenu,
    setFilterBadge,
    allArtifactList,
    setIsBadgeRemoved,
    isBadgeRemoved
  } = props;
  const { isEtmfLocked } = useSelector((store) => store.template);
  const emptyCellValue = "--";
  const [state, setState] = useState(false);
  const [agGridData, setAggridData] = useState([]);
  const [rowData, setrowData] = useState(props.rowList);
  const [customizedColState, setCustomizedColState] = useState(
    sessionStorage.getItem("customizedColState")
  );
  const [customizedFilterState, setCustomizedFilterState] = useState(
    sessionStorage.getItem("customizedFilterState")
  );
  const {
    userList,
    apiInitConfigObj,
    countrySiteList,
    studyUserInfo,
    recordState,
  } = useSelector((store) => store.zone);
  const {
    datePattern,
    dateLocale,
    fullDateTimePattern,
    deatilspagecontentseparate,
  } = useSelector((store) => store.template);

  const { deletingDocuments } = useSelector((store) => store.document);

  const dispatch = useDispatch();
  const [exportFileName, setExportFileName] = useState({
    fileName:
      studyUserInfo.studyName?.replace(/[\/\\:*?."<>|]/g, "_") +
      "_DetailsPage_" +
      UtilsHelper.getUtcCurrentTimeforExport(),
    sheetName: "Details page",
  });
  const [count, setCount] = useState(0);

  useEffect(() => {
    props.setGridContainerRef(gridRef);
  }, [props.setGridContainerRef]);

  useEffect(() => {
    if (apiInitConfigObj?.aggridaccess) {
      setState(true);
      const aggridKey = atob(apiInitConfigObj?.aggridaccess);
      LicenseManager.setLicenseKey(aggridKey);
    }
  }, [apiInitConfigObj]);

  const writePermission = (documentDetails) => {
    let permissionObject = {};
    if (!documentDetails.tmfdropzoneid) {
      const foundObj = _.find(allArtifactList, {
        origid: documentDetails.origiartifactid,
      });
      let docDetailData = {
        docDetail: documentDetails,
        artifactDetail: foundObj,
      };
      const getDocData = props.rowList.filter(
        (item) => item.docid === docDetailData.docDetail.docid
      );
      docDetailData = {
        ...docDetailData,
        docDetail: {
          ...docDetailData.docDetail,
          datingconventiondate: getDocData[0].datingconventiondate,
        },
      };
      const reqObject = {
        artifactuseraccess: foundObj?.artifactuseraccess || [],
        rolePermission: foundObj?.rolePermission,
        documenttmflevel: documentDetails.documenttmflevel,
        sitesid: documentDetails.sitesid,
        countriesid: documentDetails.countriesid,
        countrySiteList,
      };
      permissionObject = UtilsHelper.permissionObject(reqObject);
    }
    if (!_.isEmpty(permissionObject)) {
      return permissionObject.writePermission;
    } else return true;
  };

  const initialCustomized = () => {
    doCustomizedColumn(customizedColState, customizedFilterState);
    if (customizedFilterState === "{}") {
      setCount((prevState) => prevState + 1);
    }
  };
  useEffect(() => {
    let getTempCustomizeState = sessionStorage.getItem(
      "tempCustomizedColState"
    );
    let getTempCustomizeFilter = sessionStorage.getItem(
      "tempCustomizedFilterState"
    );
    setTimeout(() => {
      if (currentMode === "") {
        customizedColState !== "{}"
          ? getTempCustomizeState !== null
            ? doCustomizedColumn(getTempCustomizeState, getTempCustomizeFilter)
            : initialCustomized()
          : doDefaultColumn();
      } else {
        customizedColState !== "{}"
          ? getTempCustomizeState !== null
            ? doCustomizedColumn(getTempCustomizeState, getTempCustomizeFilter)
            : currentMode === "Customized"
            ? initialCustomized()
            : currentMode === "Default" && doDefaultColumn()
          : doDefaultColumn();
      }
    }, 60);
  }, []);

  const addIcons = (columnState) => {
    let columnStateWithIcons = [{}];
    if (!_.isEmpty(columnState) && columnState != "null") {
      columnState.map((column, i) => {
        if (column !== null) {
          if (column.colId === "zoneicon") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconRenderer("zones", props),
            };
          } else if (column.colId === "zoneicon_2") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "zoneid", "zones"),
            };
          } else if (column.colId === "zoneicon_3") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "zone", "zones"),
            };
          } else if (column.colId === "zoneicon_3") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconRenderer("zones", props),
            };
          } else if (column.colId === "sectionicon") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconRenderer("sections", props),
            };
          } else if (column.colId === "sectionicon_1") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "sectionid", "sections"),
            };
          } else if (column.colId === "sectionicon_2") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "section", "sections"),
            };
          } else if (column.colId === "artifacticon") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconRenderer("artifacts", props),
            };
          } else if (column.colId === "artifacticon_1") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "artifactid", "artifacts"),
            };
          } else if (column.colId === "artifacticon_2") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "artifact", "artifacts"),
            };
          } else if (column.colId === "type") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => RenderType(props),
            };
          } else if (column.colId === "type_2" || column.colId === "type_1") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "type"),
            };
          } else if (column.colId === "dispdocname") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "dispdocname"),
            };
          } else if (column.colId === "displaytemplate") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "displaytemplate"),
            };
          } else if (column.colId === "docname") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "docname"),
            };
          } else if (column.colId === "downloadtemplate") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "downloadtemplate"),
            };
          } else if (column.colId === "archivetemplate") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "archivetemplate"),
            };
          } else if (column.colId === "datingconventionlabel") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "datingconventionlabel"),
            };
          } else if (column.colId === "username") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "username"),
            };
          } else if (column.colId === "lastreviewedusername") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "lastreviewedusername"),
            };
          } else if (column.colId === "documenttmflevel") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "documenttmflevel"),
            };
          } else if (column.colId === "documenttype") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "documenttype"),
            };
          } else if (column.colId === "countrynames") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (params) =>
                params.data.countrynames.length > 0
                  ? params.data.countrynames.join(", ")
                  : emptyCellValue,
            };
          } else if (column.colId === "countrycodes") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (params) =>
                params.data.countrycodes.length > 0
                  ? params?.data?.countrycodes.length > 1
                    ? `${params?.data?.countrycodes},`
                    : params?.data?.countrycodes
                  : emptyCellValue,
            };
          } else if (column.colId === "sitenames") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (params) =>
                params.data.sitenames.length > 0
                  ? params.data.sitenames.join(", ")
                  : emptyCellValue,
            };
          } else if (column.colId === "sitecodes") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (params) =>
                params.data.sitecodes.length > 0
                  ? params.data.sitecodes.length > 1
                    ? `${params?.data?.sitecodes},`
                    : params.data.sitecodes
                  : emptyCellValue,
            };
          } else if (column.colId === "version") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "version"),
            };
          } else if (column.colId === "documentsystemversion") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "documentsystemversion"),
            };
          } else if (column.colId === "filesystemversion") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "filesystemversion"),
            };
          } else if (column.colId === "fileintegrity") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "fileintegrity"),
            };
          } else if (column.colId === "validdocid") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "validdocid"),
            };
          } else if (column.colId === "origfilename") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "origfilename"),
            };
          } else if (column.colId === "filesizeformatted") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "filesizeformatted"),
            };
          } else if (column.colId === "milestonegroup") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "milestonegroup"),
            };
          } else if (column.colId === "milestone") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) => IconValueRender(props, "milestone"),
            };
          } else if (column.colId === "unresolveddocumentnotescount") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                IconValueRender(props, "unresolveddocumentnotescount"),
            };
          } else if (column.colId === "status") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                DocumentStatus(
                  ["lock", "check"],
                  props,
                  onDownloadIconClick,
                  setIsDocViewVisible,
                  documentDetailsHandler,
                  deletePopup
                ),
            };
          } else if (column.colId === "preview") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellStyle: { borderRightWidth: "0" },
              cellRenderer: (props) =>
                DocumentStatus(
                  !apiInitConfigObj.previewsupportedfiletypes.includes(
                    props.data.type.toLowerCase()
                  )
                    ? ["visibility_off"]
                    : ["visibility"],
                  props,
                  onDownloadIconClick,
                  setIsDocViewVisible,
                  documentDetailsHandler,
                  deletePopup
                ),
            };
          } else if (column.colId === "agaction") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellStyle: { borderRightWidth: "0" },
              cellRenderer: (props) =>
                DocumentStatus(
                  ["download"],
                  props,
                  onDownloadIconClick,
                  setIsDocViewVisible,
                  documentDetailsHandler,
                  deletePopup
                ),
            };
          } else if (column.colId === "delaction") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: (props) =>
                DocumentStatus(
                  !isEtmfLocked && writePermission(props.data)
                    ? ["delete_outlined"]
                    : [],
                  props,
                  onDownloadIconClick,
                  setIsDocViewVisible,
                  documentDetailsHandler,
                  deletePopup
                ),
            };
          } else if (column.colId === "lastmodifieddateformatted") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              filterParams: {
                valueFormatter: (params) =>
                  dateFormatter(params, fullDateTimePattern),
              },
              valueFormatter: (params) => {
                const formatDate = dateFormatter(params, fullDateTimePattern);
                return formatDate ? formatDate : emptyCellValue;
              },
            };
          } else if (column.colId === "lastrevieweddatetimeformatted") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              filterParams: {
                valueFormatter: (params) =>
                  dateFormatter(params, fullDateTimePattern),
              },
              valueFormatter: (params) => {
                const formatDate = dateFormatter(params, fullDateTimePattern);
                return formatDate ? formatDate : emptyCellValue;
              },
            };
          } else if (column.colId === "datingconventiondate") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              valueFormatter: (params) => {
                const formatDate = dateFormatterNoLocalConversion(
                  params,
                  datePattern
                );
                return formatDate ? formatDate : emptyCellValue;
              },
              filterParams: {
                valueFormatter: (params) =>
                  dateFormatterNoLocalConversion(params, datePattern),
              },
            };
          } else if (column.colId === "ichcode") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              cellRenderer: ICHValueCellRenderer,
              filterParams: {
                valueFormatter: (params) => ICHCodeValuePattern(params),
              },
            };
          } else if (column.colId === "dropzonedate") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              filterParams: {
                valueFormatter: (params) =>
                  dateFormatter(params, fullDateTimePattern),
              },
              valueFormatter: (params) => {
                const formatDate = dateFormatter(params, fullDateTimePattern);
                return formatDate ? formatDate : emptyCellValue;
              },
            };
          } else if (column.colId === "etmfcreatedon") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              filterParams: {
                valueFormatter: (params) =>
                  dateFormatter(params, fullDateTimePattern),
              },
              valueFormatter: (params) => {
                const formatDate = dateFormatter(params, fullDateTimePattern);
                return formatDate ? formatDate : emptyCellValue;
              },
            };
          } else if (column.colId === "filedateformatted") {
            columnStateWithIcons[i] = {
              ...column,
              ...customColumn,
              filterParams: {
                valueFormatter: (params) =>
                  dateFormatter(params, fullDateTimePattern),
              },
              valueFormatter: (params) => {
                const formatDate = dateFormatter(params, fullDateTimePattern);
                return formatDate ? formatDate : emptyCellValue;
              },
            };
          } else {
            columnStateWithIcons[i] = column;
          }
          gridRef.current !== null &&
            gridRef.current !== undefined &&
            gridRef.current.api !== undefined &&
            gridRef.current.api?.setColumnDefs(columnStateWithIcons);
        }
      });
    }
  };

  const doCustomizedColumn = (colState, colFilter) => {
    if (_.isEmpty(gridRef.current)) return;
    setTimeout(() => {
      addIcons(JSON.parse(colState));
      gridRef.current !== null &&
      gridRef.current !== undefined &&
      gridRef.current.api !== undefined &&
      gridRef.current?.api?.setFilterModel !== undefined &&
      !props.isLoading &&
      recordState !== "/records" &&
      !_.isEmpty(recordState)
        ? setFilter(recordState)
        : gridRef.current.api.setFilterModel(JSON.parse(colFilter));
      //check the above condition for filter pages in next release
      setCurrentMode("Customized");
    }, 60);
    setTimeout(() => {
      gridRef.current !== null &&
        gridRef.current !== undefined &&
        gridRef?.current?.api?.redrawRows();
    }, 200);
    setTimeout(() => {
      gridRef.current !== null &&
        getAgResultCount(gridRef?.current?.api?.getDisplayedRowCount());
    }, 250);
  };
  const doDefaultColumn = () => {
    clearAggridValues("default");
    setTimeout(() => {
      const commonSearchInfo = StorageHelper.getRecentSearchInfo();
      const recentSearchInfo = JSON.parse(
        StorageHelper.getRecentAggridSearchInfo()
      );
      let searchData = "";
      let searchKey = "";
      if (
        !_.isEmpty(commonSearchInfo) &&
        (commonSearchInfo.searchKey !== "" ||
          commonSearchInfo.searchKey === "") &&
        (commonSearchInfo.category === "" || !commonSearchInfo.category)
      ) {
        if (recentSearchInfo !== null) {
          if (
            recentSearchInfo.sectionid &&
            recentSearchInfo.sectionid !== "" &&
            recentSearchInfo.sectionid !== null
          ) {
            searchData = recentSearchInfo.sectionid;
            searchKey = "sectionicon";
          } else if (
            recentSearchInfo.artifactid &&
            recentSearchInfo.artifactid !== "" &&
            recentSearchInfo.artifactid !== null
          ) {
            searchData = recentSearchInfo.artifactid;
            searchKey = "artifacticon";
          } else if (
            recentSearchInfo.category &&
            recentSearchInfo.category !== ""
          ) {
            searchData = recentSearchInfo.category;
            searchKey = "zoneicon";
          }
        }
      } else if (
        !_.isEmpty(commonSearchInfo) &&
        commonSearchInfo.searchKey === "" &&
        commonSearchInfo.category !== ""
      ) {
        searchData = recentSearchInfo.category;
        searchKey = "zoneicon";
      }
      let tempDefaultColState = sessionStorage.getItem("tempDefaultColState");
      let tempDefaultFilterState = sessionStorage.getItem(
        "tempDefaultFilterState"
      );
      if (searchKey !== "" && searchData !== "") {
        gridRef.current.api.setColumnDefs([]);
        gridRef.current.api.setFilterModel({});
        tempDefaultColState !== null
          ? gridRef.current.api.setColumnDefs(
              addIcons(JSON.parse(tempDefaultColState))
            )
          : gridRef.current.api.setColumnDefs(columnDefs);
        const instances = gridRef.current.api.getFilterInstance(searchKey);
        instances.setModel({ values: [searchData] });
        gridRef.current.api.onFilterChanged();
      } else {
        if (tempDefaultColState !== null) {
          addIcons(JSON.parse(tempDefaultColState));
          gridRef.current.api.setFilterModel(
            JSON.parse(tempDefaultFilterState)
          );
        } else {
          gridRef?.current?.api.setColumnDefs([]);
          gridRef?.current?.api.setFilterModel({});
          gridRef?.current !== null &&
            gridRef?.current?.api.setColumnDefs(columnDefs);
          gridRef?.current !== null && gridRef?.current?.api.setFilterModel({});
        }
      }
      if (customizedColState === "{}" && customizedFilterState === "{}") {
        setCount(count + 1);
      }
      setCurrentMode("Default");
      if (!isFilterHappend) {
        setDropDownChangedFilter(false);
      }
      gridRef?.current !== undefined &&
        getAgResultCount(gridRef?.current?.api?.getDisplayedRowCount());
    }, 500);
  };
  const IconValueRender = (props, fieldName, from) => {
    const { isdeletedzone, isdeletedsection, isdeletedartifact } = props.data;
    const strikeValue = () => {
      if (!props.data[fieldName]) return false;
      else if (from === "zones") return isdeletedzone;
      else if (from === "sections") return isdeletedsection;
      else if (from === "artifacts") return isdeletedartifact;
      else return false;
    };
    return (
      <span className={`${strikeValue() ? "line-through" : ""}`}>
        {props.data[fieldName] || props.data[fieldName] === 0
          ? props.data[fieldName]
          : emptyCellValue}
      </span>
    );
  };
  const getCustomized = useCallback((onload = false) => {
    gridRef.current !== null &&
      gridRef.current !== undefined &&
      gridRef.current.api !== undefined &&
      gridRef.current.api.showLoadingOverlay();
    setTimeout(() => {
      let customColState = sessionStorage.getItem("customizedColState");
      let customFilState = sessionStorage.getItem("customizedFilterState");
      doCustomizedColumn(customColState, customFilState);
      if (!isFilterHappend) {
        setDropDownChangedFilter(false);
      }
    }, 50);
    gridRef.current !== null &&
      gridRef.current !== undefined &&
      gridRef.current.api !== undefined &&
      gridRef.current.api.hideOverlay();
  }, []);

  const setBadgeRemoveState = (badgeState) => {
    setIsBadgeRemoved(badgeState);
  }

  const onChangePreference = (e) => {
    setDropDownChanged(true);
    setDropDownChangedFilter(true);
    clearAggridValues(currentMode);
    if (e === "Default") {
      setBadgeRemoveState(false);
      setIsGridReset(false);
      setAgFilterValue(true);
      clearAggridValues("custom");
      doDefaultColumn();
      props.setExtraFilters([]);
      setFilterBadge(null);
      gridRef.current.api.setFilterModel(null);
      dispatch(zoneActions.getRecordState("/records"));
    } else if (e === "Customized") {
      setBadgeRemoveState(false);
      setIsGridReset(false);
      setAgFilterValue(true);
      clearAggridValues("default");
      getCustomized(false);
    } else if (e === "Reset Columns") {
      setBadgeRemoveState(false);
      setIsGridReset(true);
      resetState(currentMode);
    } else if (e === "Save as customized") {
      if (isCustomizedChanged || isDefaultChanged || isBadgeRemoved) {
        saveState(currentMode);
        setBadgeRemoveState(false);
      }
    }
  };

  useEffect(() => {
    if (!_.isEmpty(rowData)) {
      let newDocItem = [];
      rowData.map((doc, index) => {
        let lastModifiedOn = doc.lastmodifiedon
          ? doc.lastmodifiedon
          : doc.createdon;
        let userName = UtilsHelper.findUserName(
          userList,
          doc.lastmodifiedby ? doc.lastmodifiedby : doc.createdby
        );
        let dispdocname =
          doc.displaytemplate && doc.displaytemplate !== ""
            ? doc.displaytemplate
            : doc.documentname
            ? doc.documentname
            : doc.filename;

        let docname = doc.tmfdropzoneid
          ? doc.filename
          : doc.title === "customName"
          ? doc.customTitle
          : APP_CONST.TITLE_ARRAY.includes(doc.title)
          ? doc.documenttypevalue || doc.artifact
          : doc.documentname;

        let filesize = UtilsHelper.getFileSize(doc.sizeinbytes);

        let siteids = [];
        let countryids = [];
        let sitenames = [];
        let countrynames = [];
        if (!_.isEmpty(doc.sitesid)) {
          doc.sitesid.map((ind) => {
            let val = countrySiteList.site.filter((i) => i.id === ind);
            if (!_.isEmpty(val)) {
              sitenames.push(val[0].description);
              siteids.push(val[0].siteCode);
              countryids.push(val[0].countryCode);
              let cname = countrySiteList.country.filter(
                (i) => i.countrycode === val[0].countryCode
              );
              countrynames.push(cname[0].description);
            }
          });
        }
        if (!_.isEmpty(doc.countriesid)) {
          doc.countriesid.map((con) => {
            let val = countrySiteList.country.filter((c) => c.id === con);
            if (!_.isEmpty(val)) {
              countryids.push(val[0].countrycode);
              countrynames.push(val[0].description);
            }
          });
        }
        let uniquesiteId = Array.from(new Set(siteids));
        let uniquecountryId = Array.from(new Set(countryids));
        let uniquesitenames = Array.from(new Set(sitenames));
        let uniquecountrynames = Array.from(new Set(countrynames));
        let dropzonedate = doc.dropzonecreatedon
          ? doc.dropzonecreatedon
          : doc.dropzoneuploaddatetime
        let etmfcreatedon =
          doc.dropzonecreatedon || doc.dropzoneuploaddatetime
            ? doc.etmfuploaddatetime
            : doc.createdon

        let lastreviewedusername = UtilsHelper.findUserName(
          userList,
          doc.lastreviewedby ? doc.lastreviewedby : ""
        );
        let lastrevieweddatetimeformatted = doc.lastrevieweddatetime
        let datingConventionValue =
          doc.datingconventiondate && doc.datingconventiondate;
        let filedateformatted =
          doc.tmfdropzoneid === null && doc.filedate
            ? doc.filedate
            : doc.dropzonecreatedon

        let documentsystemversion =
          doc.documentsystemversion && doc.documentsystemversion !== 0
            ? doc.documentsystemversion
            : "";
        let fileintegrity =
          doc.fileintegrity && doc.fileintegrity !== undefined
            ? doc.fileintegrity
            : "";
        let filesystemversion =
          doc.filesystemversion && doc.filesystemversion !== 0
            ? doc.filesystemversion
            : "";
        let validzoneid =
          doc.zoneid && doc.zoneid !== "0" && doc.zoneid !== 0
            ? doc.zoneid
            : "";
        let validdocid = doc.docid && doc.docid !== 0 ? doc.docid : "";
        newDocItem[index] = {
          ...doc,
          lastmodifieddateformatted: lastModifiedOn,
          username: userName,
          dispdocname: dispdocname,
          docname: docname,
          filesizeformatted: filesize,
          countrycodes: uniquecountryId,
          sitecodes: uniquesiteId,
          countrynames: uniquecountrynames,
          sitenames: uniquesitenames,
          dropzonedate: dropzonedate,
          etmfcreatedon: etmfcreatedon,
          lastreviewedusername: lastreviewedusername,
          lastrevieweddatetimeformatted: lastrevieweddatetimeformatted,
          filedateformatted: filedateformatted,
          documentsystemversion: documentsystemversion,
          fileintegrity: fileintegrity,
          filesystemversion: filesystemversion,
          validzoneid: validzoneid,
          validdocid: validdocid,
          datingconventiondate: datingConventionValue,
        };
      });

      setAggridData(newDocItem);
    }
  }, [rowData, location.pathname]);
  useEffect(() => {
    if (selectedValue !== "" && !isGridReset) {
      dropdownChange &&
        dropdownChangeFilter &&
        onChangePreference(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    !_.isEmpty(gridRef.current) && setFilter(recordState);
  }, [recordState]);

  const IconRenderer = (name, props) => {
    const { isdeletedzone, isdeletedsection, isdeletedartifact } = props.data;
    let dropZone;
    if (props.data.zone === "Drop Zone") {
      if (props.data.zoneicon === "Private" && name === "zones") {
        dropZone = "avatar";
      } else if (props.data.zoneicon === "Shared" && name === "zones") {
        dropZone = "sharing";
      } else {
        dropZone = "blank";
      }
    }
    const strikeValue = () => {
      if (name === "zones") return isdeletedzone;
      else if (name === "sections") return isdeletedsection;
      else if (name === "artifacts") return isdeletedartifact;
    };

    return (
      <div className="icon-list">
        <div className="icon-container-list">
          {props.data.zone && dropZone !== "blank" ? (
            <viedoc-icon
              attribute="nocolor"
              title={
                name === "zones"
                  ? props.data.zoneicon
                  : name === "sections"
                  ? props.data.sectionicon
                  : name === "artifacts"
                  ? props.data.artifacticon
                  : ""
              }
              name={props.data.zone === "Drop Zone" ? dropZone : name}
              class={`${strikeValue() ? "zones-dark" : ""}`}
            />
          ) : (
            emptyCellValue
          )}
        </div>
      </div>
    );
  };

  const RenderType = (val) => {
    return (
      <div className="icon-list">
        <div className="icon-inner-list">
          {val.data.type ? (
            <viedoc-icon
              attibute={"icon"}
              title={val.data.type}
              name={docList(val.data)}
              class={docList(val.data)}
            />
          ) : (
            emptyCellValue
          )}
        </div>
      </div>
    );
  };

  const docList = (documentData) => {
    let assign = "";
    switch (documentData.type) {
      case "xlsx":
      case "xls":
        assign = "xls";
        break;
      case "pdf":
        assign = "pdf";
        break;
      case "docx":
        assign = "doc";
        break;
      default:
        assign = "insert_drive_file";
        break;
    }
    return assign;
  };

  let customColumn = {
    // headerName: "",
    // enablePivot: false,
    // enableValue: false,
    // pivot: false,
    // filter: false,
    // sort: null,
    // sortable: false,
    // width: 75,
    // minWidth: 75,
    cellStyle: { textAlign: "left", borderRightColor: "#e2e2e2" },
    // menuTabs: [],
  };
  const myIcons = {
    icons: {
      sortAscending:
        '<div class="header-arrow"><viedoc-icon name="north" /><div>',
      sortDescending:
        '<div class="header-arrow"><viedoc-icon name="down_arrow" /><div>',
    },
  };

  const listToString = (inputData, propList) => {
    let returnList = _.isEmpty(inputData)
      ? ""
      : inputData.map((obj, i) => {
          const findObj = _.find(propList, { id: obj });
          return `${!_.isEmpty(findObj) ? `${findObj.description}` : ""}`;
        });
    returnList = _.isEmpty(inputData)
      ? ""
      : returnList.filter((list) => !_.isEmpty(list) && list);
    returnList = _.isEmpty(inputData) ? "" : returnList.join(", ");
    return _.isEmpty(inputData) ? "" : returnList;
  };

  const dateFormatter = (params, pattern) => {
    const formattedDate = pattern
      ? UtilsHelper.getFormattedDateTime(pattern, params.value, dateLocale)
      : params.value;
    return formattedDate;
  };
  const dateFormatterNoLocalConversion = (params, pattern) => {
    const formattedDate = pattern
      ? UtilsHelper.getFormattedDateTimeNoLocalConversion(
          pattern,
          params.value,
          dateLocale
        )
      : params.value;
    return formattedDate;
  };
  const sideCodeFormatter = (params) => {
    let siteids = [];
    if (!_.isEmpty(params.data.sitesid)) {
      params.data.sitesid.map((ind) => {
        let val = countrySiteList.site.filter((i) => i.id === ind);
        if (!_.isEmpty(val)) {
          siteids.push(val[0].siteCode);
        }
      });
    }
    return Array.from(new Set(siteids));
  };
  const fileSizeFormatter = (params) => {
    let filesize = UtilsHelper.getFileSize(params.data.sizeinbytes);
    return filesize;
  };
  const addColumnHeaderNameFields = () => {
    let resetColumnState = [{}];
    window.colState = gridRef.current.columnApi.getColumnState();
    window.colState.map((states, index) => {
      if (states.colId === "zoneicon") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ZONE"),
          field: "zoneicon",
          cellRenderer: (props) => IconRenderer("zones", props),
        };
      } else if (states.colId === "zoneicon_1") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ZONENO"),
          field: "zoneicon",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "zoneicon_2") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ZONENO"),
          field: "zoneicon",
          cellRenderer: (props) => IconValueRender(props, "zoneid", "zones"),
        };
      } else if (states.colId === "zoneicon_3") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ZONENAME"),
          field: "zoneicon",
          cellRenderer: (props) => IconValueRender(props, "zone", "zones"),
        };
      } else if (states.colId === "sectionicon") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_SECTION"),
          field: "sectionicon",
          cellRenderer: (props) => IconRenderer("sections", props),
        };
      } else if (states.colId === "sectionicon_1") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_SECTIONNO"),
          field: "sectionicon",
          cellRenderer: (props) =>
            IconValueRender(props, "sectionid", "sections"),
        };
      } else if (states.colId === "sectionicon_2") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_SECTIONNAME"),
          field: "sectionicon",
          cellRenderer: (props) =>
            IconValueRender(props, "section", "sections"),
        };
      } else if (states.colId === "artifacticon") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ARTIFACT"),
          field: "artifacticon",
          cellRenderer: (props) => IconRenderer("artifacts", props),
        };
      } else if (states.colId === "artifacticon_1") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ARTIFACTNO"),
          field: "artifacticon",
          cellRenderer: (props) =>
            IconValueRender(props, "artifactid", "artifacts"),
          filter: "agSetColumnFilter",
        };
      } else if (states.colId === "artifacticon_2") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ARTIFACTNAME"),
          field: "artifacticon",
          cellRenderer: (props) =>
            IconValueRender(props, "artifact", "artifacts"),
          filter: "agSetColumnFilter",
        };
      } else if (states.colId === "type") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_FILETYPE"),
          field: "type",
          cellRenderer: (props) => RenderType(props),
        };
      } else if (states.colId === "type_2" || states.colId === "type_1") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_FILETYPENAME"),
          field: "type",
        };
      } else if (states.colId === "sectionid") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_SECTIONNAME"),
          field: "sectionid",
          filter: "agSetColumnFilter",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "artifactid") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ARTIFACTNAME"),
          field: "artifactid",
          filter: "agSetColumnFilter",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "dispdocname") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_NAME"),
          field: "dispdocname",
        };
      } else if (states.colId === "filename") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_NAME"),
          field: "filename",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "displaytemplate") {
        resetColumnState[index] = {
          ...states,

          headerName: t("DETAILPAGE.LABEL_DISPLAYLABEL"),

          field: "displaytemplate",
        };
      } else if (states.colId === "documentname") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DOCUMENTNAME"),
          field: "documentname",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "docname") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DOCUMENTNAME"),
          field: "docname",
        };
      } else if (states.colId === "downloadtemplate") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DOWNLOADLABEL"),
          field: "downloadtemplate",
        };
      } else if (states.colId === "archivetemplate") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ARCHIVELABEL"),
          field: "archivetemplate",
        };
      } else if (states.colId === "datingconventionlabel") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DATINGCONVENTION"),
          field: "datingconventionlabel",
        };
      } else if (states.colId === "datingconventiondate") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DATINGCONVENTIONVALUE"),
          field: "datingconventiondate",
        };
      } else if (states.colId === "lastmodifieddateformatted") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_LASTMODIFIEDDATETIME"),
          field: "lastmodifieddateformatted",
          resizable: true,
        };
      } else if (states.colId === "lastmodifiedon") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_LASTMODIFIEDDATETIME"),
          field: "lastmodifiedon",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "username") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_LASTMODIFIEDBY"),
          field: "username",
          resizable: true,
        };
      } else if (states.colId === "lastmodifiedby") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_LASTMODIFIEDBY"),
          field: "lastmodifiedby",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "lastrevieweddatetime") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_LASTREVIEWEDDATETIME"),
          field: "lastrevieweddatetime",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "lastrevieweddatetimeformatted") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_LASTREVIEWEDDATETIME"),
          field: "lastrevieweddatetimeformatted",
        };
      } else if (states.colId === "lastreviewedusername") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_LASTREVIEWEDBY"),
          field: "lastreviewedusername",
        };
      } else if (states.colId === "lastreviewedby") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_LASTREVIEWEDBY"),
          field: "lastreviewedby",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "dropzonecreatedon") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_UPLOADEDTODROPZONEDATETIME"),
          field: "dropzonecreatedon",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "dropzonedate") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_UPLOADEDTODROPZONEDATETIME"),
          field: "dropzonedate",
        };
      } else if (states.colId === "etmfcreatedon") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_UPLOADEDTOETMFDATETIME"),
          field: "etmfcreatedon",
        };
      } else if (states.colId === "documenttmflevel") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_TMFLEVEL"),
          field: "documenttmflevel",
          resizable: true,
        };
      } else if (states.colId === "documenttype") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DOCUMENTTYPE"),
          field: "documenttype",
        };
      } else if (states.colId === "countrynames") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_COUNTRY"),
          field: "countrynames",
          resizable: true,
        };
      } else if (states.colId === "countriesid") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_COUNTRYCODES"),
          field: "countriesid",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "countrycodes") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_COUNTRYCODES"),
          field: "countrycodes",
        };
      } else if (states.colId === "sitenames") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_SITE"),
          field: "sitenames",
          resizable: true,
        };
      } else if (states.colId === "lastreviewedby") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_LASTREVIEWEDBY"),
          field: "lastreviewedby",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "sitesid") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_SITECODES"),
          field: "sitesid",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "sitecodes") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_SITECODES"),
          field: "sitecodes",
        };
      } else if (states.colId === "version") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_VERSIONLABEL"),
          field: "version",
        };
      } else if (states.colId === "documentsystemversion") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DOCUMENTVERSION"),
          field: "documentsystemversion",
        };
      } else if (states.colId === "filesystemversion") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_FILEVERSION"),
          field: "filesystemversion",
        };
      } else if (states.colId === "fileintegrity") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_FILEINTEGRITY"),
          field: "fileintegrity",
        };
      } else if (states.colId === "docid") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DOCUMENTID"),
          field: "docid",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "validdocid") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DOCUMENTID"),
          field: "validdocid",
        };
      } else if (states.colId === "ichcode") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ICHCODE"),
          field: "ichcode",
        };
      } else if (states.colId === "origfilename") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ORIGINALFILENAME"),
          field: "origfilename",
        };
      } else if (states.colId === "filesizeformatted") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_FILESIZE"),
          field: "filesizeformatted",
        };
      } else if (states.colId === "sizeinbytes") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_FILESIZE"),
          field: "sizeinbytes",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "filedate") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_FILEDATE"),
          field: "filedate",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressMenu: true,
        };
      } else if (states.colId === "filedateformatted") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_FILEDATE"),
          field: "filedateformatted",
        };
      } else if (states.colId === "milestonegroup") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_MILESTONEGROUP"),
          field: "milestonegroup",
        };
      } else if (states.colId === "milestone") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_MILESTONE"),
          field: "milestone",
        };
      } else if (states.colId === "unresolveddocumentnotescount") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_UNRESOLVEDNOTESCOUNT"),
          field: "unresolveddocumentnotescount",
        };
      } else if (states.colId === "status") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_DOCUMENTSTATUS"),
          field: "status",
          cellRenderer: (props) =>
            DocumentStatus(
              ["lock", "check"],
              props,
              onDownloadIconClick,
              setIsDocViewVisible,
              documentDetailsHandler,
              deletePopup
            ),
        };
      } else if (states.colId === "preview") {
        resetColumnState[index] = {
          ...states,
          headerName: t("DETAILPAGE.LABEL_ACTIONS"),
          field: "preview",
          ...myIcons,
          cellStyle: { borderRightWidth: "0" },
          cellRenderer: (props) =>
            DocumentStatus(
              !apiInitConfigObj.previewsupportedfiletypes.includes(
                props.data.type.toLowerCase()
              )
                ? ["visibility_off"]
                : ["visibility"],
              props,
              onDownloadIconClick,
              setIsDocViewVisible,
              documentDetailsHandler,
              deletePopup
            ),
          pinned: "right",
          suppressColumnsToolPanel: true,
          suppressMenu: true,
          sortable: false,
          suppressMovable: true,
          resizable: false,
        };
      } else if (states.colId === "agaction") {
        resetColumnState[index] = {
          ...states,
          headerName: "",
          field: "agaction",
          ...myIcons,
          cellStyle: { borderRightWidth: "0" },
          cellRenderer: (props) =>
            DocumentStatus(
              ["download"],
              props,
              onDownloadIconClick,
              setIsDocViewVisible,
              documentDetailsHandler,
              deletePopup
            ),
          pinned: "right",
          suppressColumnsToolPanel: true,
          suppressMenu: true,
          sortable: false,
          suppressMovable: true,
        };
      } else if (states.colId === "delaction") {
        resetColumnState[index] = {
          ...states,
          headerName: "",
          field: "delaction",
          ...myIcons,
          cellRenderer: (props) =>
            DocumentStatus(
              !isEtmfLocked && writePermission(props.data)
                ? ["delete_outlined"]
                : [],
              props,
              onDownloadIconClick,
              setIsDocViewVisible,
              documentDetailsHandler,
              deletePopup
            ),
          pinned: "right",
          suppressColumnsToolPanel: true,
          suppressMenu: true,
          sortable: false,
          suppressMovable: true,
        };
      }
    });
    return resetColumnState;
  };
  const resetState = useCallback((preState) => {
    gridRef.current.api.showLoadingOverlay();
    if (preState === "Customized") {
      getCustomized(false);
      setSelectedValue("Customized");
      setCurrentMode("Customized");
      clearAggridValues("custom");
    } else if (preState === "Default") {
      setSelectedValue("Default");
      setCurrentMode("Default");
      doDefaultColumn();
      clearAggridValues("default");
    }
    gridRef.current.api.hideOverlay();
  }, []);
  const setAggrigValuesToStorage = (value) => {
    if (currentMode == "Customized") {
      sessionStorage.setItem(
        "tempCustomizedColState",
        JSON.stringify(value.recentColState)
      );
      sessionStorage.setItem(
        "tempCustomizedFilterState",
        JSON.stringify(value.savedFilterModel)
      );
      setTempCustomizedColState(
        sessionStorage.getItem("tempCustomizedColState")
      );
      setTempCustomizedFilterState(
        sessionStorage.getItem("tempCustomizedFilterState")
      );
    } else if (currentMode === "Default") {
      sessionStorage.setItem(
        "tempDefaultColState",
        JSON.stringify(value.recentColState)
      );
      sessionStorage.setItem(
        "tempDefaultFilterState",
        JSON.stringify(value.savedFilterModel)
      );
      setTempDefaultColState(sessionStorage.getItem("tempDefaultColState"));
      setTempDefaultFilterState(
        sessionStorage.getItem("tempDefaultFilterState")
      );
    }
  };

  const clearAggridValues = (from) => {
    if (dropdownChange && dropdownChangeFilter) {
      if (from === "custom" || from === "Customized") {
        sessionStorage.removeItem("tempCustomizedColState");
        sessionStorage.removeItem("tempCustomizedFilterState");
        setTempCustomizedColState(
          sessionStorage.getItem("tempCustomizedColState")
        );
        setTempCustomizedFilterState(
          sessionStorage.getItem("tempCustomizedFilterState")
        );
      } else if (from === "default" || from === "Default") {
        sessionStorage.removeItem("tempDefaultColState");
        sessionStorage.removeItem("tempDefaultFilterState");
        setTempDefaultColState(sessionStorage.getItem("tempDefaultColState"));
        setTempDefaultFilterState(
          sessionStorage.getItem("tempDefaultFilterState")
        );
      }
    }
    setTempCustomizedColState(null);
    setTempCustomizedFilterState(null);
    setDropDownChanged(false);
    setDropDownChangedFilter(false);
  };
  const doSaveChangedAggridValues = (from) => {
    if (
      customizedColState !== undefined &&
      customizedFilterState !== undefined
    ) {
      const getTempCustomizeFilter = sessionStorage.getItem(
        "tempCustomizedFilterState"
      );
      const getTempDefaultFilter = sessionStorage.getItem(
        "tempDefaultFilterState"
      );
      let recentColState = addColumnHeaderNameFields();
      if (currentMode === "Customized") {
        const commonSearchInfo = StorageHelper.getRecentSearchInfo();
        let savedFilterModel =
          from === "filter"
            ? _.isEmpty(gridRef.current.api.getFilterModel()) &&
              commonSearchInfo.searchKey !== ""
              ? JSON.parse(customizedFilterState)
              : gridRef.current.api.getFilterModel()
            : getTempCustomizeFilter === null
            ? JSON.parse(customizedFilterState)
            : JSON.parse(getTempCustomizeFilter);
        if (!dropdownChange && !dropdownChangeFilter) {
          setAggrigValuesToStorage({
            recentColState: recentColState,
            savedFilterModel: savedFilterModel,
          });
        }
      } else {
        let savedFilterModel =
          from === "filter"
            ? gridRef.current.api.getFilterModel()
            : getTempDefaultFilter === null
            ? {}
            : JSON.parse(getTempDefaultFilter);
        if (!dropdownChange && !dropdownChangeFilter) {
          setAggrigValuesToStorage({
            recentColState: recentColState,
            savedFilterModel: savedFilterModel,
          });
        }
      }
    }
  };
  const onFilterChange = (event) => {
    props.captureAppliedFilter();
    setAgFilterValue(false);
    setIsGridReset(false);
    // setClickOutside(true);
    getAgResultCount(gridRef.current.api.getDisplayedRowCount());
    if (!dropdownChangeFilter) {
      setIsFilterHappend(true);
      // !isGridReset && !agFilterValue && doSaveChangedAggridValues("filter");
      count === 0
        ? setCount((prevState) => prevState + 1)
        : event?.hasOwnProperty("afterDataChange") &&
          event?.hasOwnProperty("afterFloatingFilter") &&
          doSaveChangedAggridValues("filter");
    } else {
      setIsFilterHappend(false);
      setDropDownChangedFilter(false);
      setDropDownChanged(false);
    }
    setFileCount(fileCount + 1);
  };
  const saveState = useCallback((from) => {
    gridRef.current.api.showLoadingOverlay();
    clearAggridValues(from);
    setDropDownChangedFilter(false);
    let savedFilterModel = gridRef.current.api.getFilterModel();
    let resetColumnState = addColumnHeaderNameFields();
    let reqPayload = {
      UserPreference: JSON.stringify(resetColumnState),
      FilterPreference: JSON.stringify(savedFilterModel),
    };
    setCustomizedColState(JSON.stringify(resetColumnState));
    setCustomizedFilterState(JSON.stringify(savedFilterModel));
    setCurrentMode("Customized");
    setSelectedValue("Customized");
    dispatch(documentActions.saveCustomizedColumState(reqPayload));
    // setClickOutside(false);
    gridRef.current.api.hideOverlay();
  }, []);
  const onChange = (props) => {
    setIsGridReset(false);
    setAgFilterValue(false);
    if (props.source === "api" && !props.hasOwnProperty("pinned")) {
      return;
    }
    if (dropdownChange || dropdownChangeFilter) {
      tempCustomizedColState !== null &&
        tempCustomizedFilterState !== null &&
        clearAggridValues("custom");
      tempDefaultColState !== null &&
        tempDefaultFilterState !== null &&
        clearAggridValues("default");
    } else {
      doSaveChangedAggridValues("column");
    }
  };
  const ICHCodeValuePattern = (params) => {
    let formattedICHCode = "";
    if (params.value !== null) {
      let replaceICHCodeValue = params.value.includes(`\n`)
        ? params.value.replaceAll(`\n`, `\\n`)
        : params.value;
      let splitedValues = replaceICHCodeValue.split(`\\n`);
      if (splitedValues.length !== 0) {
        splitedValues.map((code, index) => {
          formattedICHCode =
            code !== ""
              ? `${formattedICHCode}${code}${
                  splitedValues.length - 1 !== index
                    ? deatilspagecontentseparate
                    : ""
                }`
              : "";
        });
      }
    } else {
      formattedICHCode = params.value;
    }
    return formattedICHCode;
  };

  const [columnDefs, setcolumnDefs] = useState([
    {
      ...customColumn,
      minWidth: 59,
      width: 59,
      headerName: t("DETAILPAGE.LABEL_ZONE"),
      field: "zoneicon",
      enablePivot: false,
      enableValue: true,
      pivot: false,
      filter: true,
      cellRenderer: (props) => IconRenderer("zones", props),
      sort: null,
      pinned: "nopin",
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_ZONENO"),
      field: "zoneicon",
      enablePivot: false,
      pinned: "nopin",
      enableValue: true,
      pivot: false,
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
      ...myIcons,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_ZONENO"),
      field: "zoneicon",
      enablePivot: false,
      pinned: "nopin",
      enableValue: true,
      pivot: false,
      hide: true,
      ...myIcons,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "zoneid", "zones"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_ZONENAME"),
      field: "zoneicon",
      hide: true,
      ...myIcons,
      enablePivot: false,
      pinned: "nopin",
      enableValue: true,
      pivot: false,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "zone", "zones"),
    },

    {
      ...customColumn,
      minWidth: 59,
      width: 59,
      headerName: t("DETAILPAGE.LABEL_SECTION"),
      field: "sectionicon",
      pivot: false,
      pinned: "nopin",
      enablePivot: false,
      enableValue: true,
      filter: true,
      sort: null,
      cellRenderer: (props) => IconRenderer("sections", props),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_SECTIONNO"),
      field: "sectionicon",
      pivot: false,
      pinned: "nopin",
      enablePivot: false,
      hide: true,
      ...myIcons,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "sectionid", "sections"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_SECTIONNAME"),
      field: "sectionicon",
      pivot: false,
      pinned: "nopin",
      enablePivot: false,
      hide: true,
      ...myIcons,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "section", "sections"),
    },

    {
      ...customColumn,
      minWidth: 59,
      width: 59,
      headerName: t("DETAILPAGE.LABEL_ARTIFACT"),
      field: "artifacticon",
      enablePivot: false,
      pinned: "nopin",
      enableValue: true,
      pivot: false,
      filter: true,
      sort: null,
      cellRenderer: (props) => IconRenderer("artifacts", props),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_ARTIFACTNO"),
      field: "artifacticon",
      enablePivot: false,
      pinned: "nopin",
      hide: true,
      pivot: false,
      ...myIcons,
      cellRenderer: (props) =>
        IconValueRender(props, "artifactid", "artifacts"),
      filter: "agSetColumnFilter",
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_ARTIFACTNAME"),
      field: "artifacticon",
      pinned: "nopin",
      enablePivot: false,
      hide: true,
      pivot: false,
      ...myIcons,
      cellRenderer: (props) => IconValueRender(props, "artifact", "artifacts"),
      filter: "agSetColumnFilter",
      sort: null,
    },

    {
      ...customColumn,
      minWidth: 59,
      width: 59,
      headerName: t("DETAILPAGE.LABEL_FILETYPE"),
      field: "type",
      enablePivot: false,
      pinned: "nopin",
      enableValue: true,
      pivot: false,
      sort: null,
      cellRenderer: (props) => RenderType(props),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_FILETYPENAME"),
      field: "type",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "type"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.TEXT_SECTIONNAME"),
      field: "sectionid",
      pinned: "nopin",
      filter: "agSetColumnFilter",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_ARTIFACTNAME"),
      field: "artifactid",
      pinned: "nopin",
      filter: "agSetColumnFilter",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },

    {
      ...customColumn,
      width: 300,
      headerName: t("DETAILPAGE.LABEL_NAME"),
      field: "dispdocname",
      sort: null,
      pinned: "nopin",
      ...myIcons,
      cellRenderer: (props) => IconValueRender(props, "dispdocname"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_NAME"),
      field: "filename",
      hide: true,
      pinned: "nopin",
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
      ...myIcons,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_DISPLAYLABEL"),
      field: "displaytemplate",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "displaytemplate"),
    },
    {
      ...customColumn,
      width: 250,
      headerName: t("DETAILPAGE.LABEL_DOCUMENTNAME"),
      field: "documentname",
      pinned: "nopin",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      width: 250,
      headerName: t("DETAILPAGE.LABEL_DOCUMENTNAME"),
      field: "docname",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "docname"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_DOWNLOADLABEL"),
      field: "downloadtemplate",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "downloadtemplate"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_ARCHIVELABEL"),
      field: "archivetemplate",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "archivetemplate"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_DATINGCONVENTION"),
      field: "datingconventionlabel",
      pinned: "nopin",
      resizable: true,
      width: 250,
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "datingconventionlabel"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_DATINGCONVENTIONVALUE"),
      field: "datingconventiondate",
      pinned: "nopin",
      resizable: true,
      width: 250,
      hide: true,
      sort: null,
      filter: "agSetColumnFilter",
      filterParams: {
        valueFormatter: (params) =>
          dateFormatterNoLocalConversion(params, datePattern),
      },
      valueFormatter: (params) => {
        const formatDate = dateFormatterNoLocalConversion(params, datePattern);
        return formatDate ? formatDate : emptyCellValue;
      },
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_LASTMODIFIEDDATETIME"),
      field: "lastmodifieddateformatted",
      pinned: "nopin",
      resizable: true,
      width: 250,
      sort: null,
      filter: "agSetColumnFilter",
      filterParams: {
        valueFormatter: (params) => dateFormatter(params, fullDateTimePattern),
      },
      valueFormatter: (params) => {
        const formatDate = dateFormatter(params, fullDateTimePattern);
        return formatDate ? formatDate : emptyCellValue;
      },
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_LASTMODIFIEDDATETIME"),
      field: "lastmodifiedon",
      hide: true,
      pinned: "nopin",
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_LASTMODIFIEDBY"),
      field: "username",
      resizable: true,
      pinned: "nopin",
      width: 250,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "username"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_LASTMODIFIEDBY"),
      field: "lastmodifiedby",
      hide: true,
      pinned: "nopin",
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_LASTREVIEWEDDATETIME"),
      field: "lastrevieweddatetime",
      pinned: "nopin",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_LASTREVIEWEDDATETIME"),
      field: "lastrevieweddatetimeformatted",
      pinned: "nopin",
      hide: true,
      sort: null,
      filter: "agSetColumnFilter",
      filterParams: {
        valueFormatter: (params) => dateFormatter(params, fullDateTimePattern),
      },
      valueFormatter: (params) => {
        const formatDate = dateFormatter(params, fullDateTimePattern);
        return formatDate ? formatDate : emptyCellValue;
      },
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_LASTREVIEWEDBY"),
      field: "lastreviewedusername",
      hide: true,
      pinned: "nopin",
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "lastreviewedusername"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_LASTREVIEWEDBY"),
      field: "lastreviewedby",
      hide: true,
      pinned: "nopin",
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_UPLOADEDTODROPZONEDATETIME"),
      field: "dropzonecreatedon",
      pinned: "nopin",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_UPLOADEDTODROPZONEDATETIME"),
      field: "dropzonedate",
      pinned: "nopin",
      hide: true,
      sort: null,
      filter: "agSetColumnFilter",
      filterParams: {
        valueFormatter: (params) => dateFormatter(params, fullDateTimePattern),
      },
      valueFormatter: (params) => {
        const formatDate = dateFormatter(params, fullDateTimePattern);
        return formatDate ? formatDate : emptyCellValue;
      },
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_UPLOADEDTOETMFDATETIME"),
      field: "etmfcreatedon",
      pinned: "nopin",
      hide: true,
      sort: null,
      filter: "agSetColumnFilter",
      filterParams: {
        valueFormatter: (params) => dateFormatter(params, fullDateTimePattern),
      },
      valueFormatter: (params) => {
        const formatDate = dateFormatter(params, fullDateTimePattern);
        return formatDate ? formatDate : emptyCellValue;
      },
    },
    {
      ...customColumn,
      width: 200,
      headerName: t("DETAILPAGE.LABEL_TMFLEVEL"),
      field: "documenttmflevel",
      pinned: "nopin",
      resizable: true,
      sort: null,
      ...myIcons,
      cellRenderer: (props) => IconValueRender(props, "documenttmflevel"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_DOCUMENTTYPE"),
      field: "documenttype",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "documenttype"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_COUNTRIES"),
      field: "countrynames",
      pinned: "nopin",
      resizable: true,
      width: 150,
      sort: null,
      cellRenderer: (params) =>
        params.data.countrynames.length > 0
          ? params.data.countrynames.join(", ")
          : emptyCellValue,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_COUNTRYCODES"),
      field: "countriesid",
      pinned: "nopin",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_COUNTRYCODES"),
      field: "countrycodes",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (params) =>
        params.data.countrycodes.length > 0
          ? params?.data?.countrycodes
          : emptyCellValue,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_SITES"),
      field: "sitenames",
      pinned: "nopin",
      resizable: true,
      width: 150,
      sort: null,
      ...myIcons,
      cellRenderer: (params) =>
        params.data.sitenames.length > 0
          ? params.data.sitenames.join(", ")
          : emptyCellValue,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_SITECODES"),
      field: "sitesid",
      pinned: "nopin",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_SITECODES"),
      field: "sitecodes",
      pinned: "nopin",
      hide: true,
      sort: null,
      ...myIcons,
      cellRenderer: (params) =>
        params.data.sitecodes.length > 0
          ? params?.data?.sitecodes
          : emptyCellValue,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_VERSIONLABEL"),
      field: "version",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "version"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_DOCUMENTVERSION"),
      field: "documentsystemversion",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "documentsystemversion"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_FILEVERSION"),
      field: "filesystemversion",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "filesystemversion"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_FILEINTEGRITY"),
      field: "fileintegrity",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "fileintegrity"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_DOCUMENTID"),
      field: "docid",
      pinned: "nopin",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_DOCUMENTID"),
      field: "validdocid",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "validdocid"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_ORIGINALFILENAME"),
      field: "origfilename",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "origfilename"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_FILESIZE"),
      field: "filesizeformatted",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "filesizeformatted"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_FILESIZE"),
      field: "sizeinbytes",
      pinned: "nopin",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_FILEDATE"),
      field: "filedate",
      hide: true,
      pinned: "nopin",
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sort: null,
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_FILEDATE"),
      field: "filedateformatted",
      hide: true,
      pinned: "nopin",
      sort: null,
      filter: "agSetColumnFilter",
      filterParams: {
        valueFormatter: (params) => dateFormatter(params, fullDateTimePattern),
      },
      valueFormatter: (params) => {
        const formatDate = dateFormatter(params, fullDateTimePattern);
        return formatDate ? formatDate : emptyCellValue;
      },
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_MILESTONEGROUP"),
      field: "milestonegroup",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "milestonegroup"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_MILESTONE"),
      field: "milestone",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) => IconValueRender(props, "milestone"),
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_ICHCODE"),
      field: "ichcode",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: ICHValueCellRenderer,
      filterParams: {
        valueFormatter: (params) => ICHCodeValuePattern(params),
      },
    },
    {
      ...customColumn,
      headerName: t("DETAILPAGE.LABEL_UNRESOLVEDNOTESCOUNT"),
      field: "unresolveddocumentnotescount",
      pinned: "nopin",
      hide: true,
      sort: null,
      cellRenderer: (props) =>
        IconValueRender(props, "unresolveddocumentnotescount"),
    },
    {
      ...customColumn,
      width: 200,
      headerName: t("DETAILPAGE.LABEL_DOCUMENTSTATUS"),
      field: "status",
      pinned: "nopin",
      ...myIcons,
      cellRenderer: (props) =>
        DocumentStatus(
          ["lock", "check"],
          props,
          onDownloadIconClick,
          setIsDocViewVisible,
          documentDetailsHandler,
          deletePopup
        ),
      sort: null,
    },

    {
      ...customColumn,
      width: 80,
      headerName: t("DETAILPAGE.LABEL_ACTIONS"),
      field: "preview",
      ...myIcons,
      cellStyle: { borderRightWidth: "0" },
      cellRenderer: (props) =>
        DocumentStatus(
          !apiInitConfigObj.previewsupportedfiletypes.includes(
            props.data.type.toLowerCase()
          )
            ? ["visibility_off"]
            : ["visibility"],
          props,
          onDownloadIconClick,
          setIsDocViewVisible,
          documentDetailsHandler,
          deletePopup
        ),
      pinned: "right",
      menuTabs: [],
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sortable: false,
      suppressMovable: true,
      resizable: false,
      sort: null,
    },
    {
      ...customColumn,
      width: 70,
      headerName: "",
      field: "agaction",
      ...myIcons,
      cellStyle: { borderRightWidth: "0" },
      cellRenderer: (props) =>
        DocumentStatus(
          ["download"],
          props,
          onDownloadIconClick,
          setIsDocViewVisible,
          documentDetailsHandler,
          deletePopup
        ),
      pinned: "right",
      menuTabs: [],
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sortable: false,
      suppressMovable: true,
      sort: null,
    },
    {
      ...customColumn,
      width: 70,
      headerName: "",
      field: "delaction",
      ...myIcons,
      cellRenderer: (props) =>
        DocumentStatus(
          !isEtmfLocked && writePermission(props.data)
            ? ["delete_outlined"]
            : [],
          props,
          onDownloadIconClick,
          setIsDocViewVisible,
          documentDetailsHandler,
          deletePopup
        ),
      pinned: "right",
      menuTabs: [],
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      sortable: false,
      suppressMovable: true,
      sort: null,
    },
  ]);

  const getContextMenuItems = (params) => {
    var result = ["copy", "copyWithHeaders", "separator", "export"];
    return result;
  };

  const getMainMenuItems = useCallback((params) => {
    let defaultItems = [...params.defaultItems];
    defaultItems[0] = {
      name: "Pin Column",
      subMenu: [
        {
          name: "Pin Left",
          action: () =>
            params.columnApi.setColumnsPinned(
              [params.column.colDef.field],
              "left"
            ),
          icon:
            params.column.pinned === "left"
              ? '<div className="header-arrow" style="width:20px;height:20px"><viedoc-icon name="check" /><div></div>'
              : "",
        },
        "separator",
        {
          name: "Pin Right",
          action: () =>
            params.columnApi.setColumnsPinned(
              [params.column.colDef.field],
              "right"
            ),
          icon:
            params.column.pinned === "right"
              ? '<div className="header-arrow" style="width:20px;height:20px"><viedoc-icon name="check" /><div></div>'
              : "",
        },
        "separator",
        {
          name: "No Pin",
          action: () =>
            params.columnApi.setColumnsPinned(
              [params.column.colDef.field],
              null
            ),
          icon: params.column.pinned
            ? ""
            : '<div className="header-arrow" style="width:20px;height:20px"><viedoc-icon name="check" /><div></div>',
        },
      ],
    };
    defaultItems.splice(6, 1);
    defaultItems.push({
      name: "Reset columns",
      action: () => {
        let resetValueObj = {
          target: {
            value: "Reset Columns",
          },
        };
        onDropDownValuesChange(resetValueObj);
      },
      disabled: !isCustomizedChanged && !isDefaultChanged && !isBadgeRemoved,
    });
    let customizeDefaultItem = defaultItems.map((item, index) =>
      index === 5
        ? ""
        : item === "separator"
        ? { cssClasses: ["mainMenuStyle"] }
        : item
    );
    customizeDefaultItem.splice(3, 0, "separator");
    return customizeDefaultItem;
  });

  const onExportChanged = () => {
    // setClickOutside(true);
    let exportParams = {
      fileName:
        studyUserInfo.studyName?.replace(/[\/\\:*?."<>|]/g, "_") +
        "_DetailsPage_" +
        UtilsHelper.getUtcCurrentTimeforExport(),
      sheetName: "Details page",
    };
    setExportFileName(exportParams);
  };

  const setFilter = (filterPage) => {
    let docStatus = "All";
    switch (filterPage) {
      case "/flagged":
        docStatus = "Flagged by QC";
        setFilterBadge(t("TMF.TEXT_FLAGGEDBYQC"));
        break;

      case "/awaiting":
        docStatus = "Awaiting review";
        setFilterBadge(t("TMF.TEXT_AWAITING"));
        break;

      case "/finalized":
        docStatus = "Finalized";
        setFilterBadge(t("TMF.TEXT_FINALIZED"));
        break;

      default:
        setFilterBadge(null);
        break;
    }

    function getFilterValuesToSet() {
      if (filterPage === "/records" && currentMode === "Default") {
        return null;
      } else if (filterPage === "/records" && currentMode === "Customized") {
        let newFilter = sessionStorage.getItem("customizedFilterState");
        if (_.isEmpty(newFilter)) return null;
        newFilter = JSON.parse(newFilter);
        return newFilter;
      } else {
        return {
          status: {
            type: "set",
            values: [docStatus],
          },
        };
      }
    }
    gridRef.current.api.setFilterModel(getFilterValuesToSet());
    gridRef.current.api.redrawRows();
  };

  return (
    <div className="ag-theme-alpine" style={{ height: "calc(100vh - 264px)" }}>
      {state && (
        <AgGridReact
          ref={gridRef}
          defaultColDef={{
            resizable: true,
            filter: true,
            // flex: 1,
            sortable: true,
            cellStyle: { borderRightColor: "#e2e2e2" },
            icons: {
              menu: '<div class="awiting-option general-menu" style="position:relative;padding:4px;background-color: #d9d9d9;border-radius: 50%;display: inline-flex;align-items: center;justify-content: center;width: 15px;height: 15px;cursor: pointer;"><span style="font-size:20px;margin-bottom: 11px;">...</span></div>',
              filter:
                '<div className="header-arrow" style="width:20px;height:20px"><viedoc-icon name="filter" /><div></div>',
              columns:
                '<div className="header-arrow" style="width:15px;height:15px"><viedoc-icon name="visibility" /><div></div>',
              sortAscending:
                '<div class="header-arrow"><viedoc-icon name="north" /><div>',
              sortDescending:
                '<div class="header-arrow"><viedoc-icon name="down_arrow" /><div>',
            },
          }}
          columnDefs={columnDefs}
          rowData={agGridData}
          sideBar={false}
          pagination={false}
          rowSelection="multiple"
          suppressPaginationPanel={false}
          getContextMenuItems={getContextMenuItems}
          suppressMenuHide={true}
          getMainMenuItems={getMainMenuItems}
          onColumnVisible={onChange}
          onColumnPinned={onChange}
          onColumnResized={onChange}
          onColumnMoved={onChange}
          onSortChanged={onChange}
          onFilterChanged={onFilterChange}
          defaultCsvExportParams={exportFileName}
          defaultExcelExportParams={exportFileName}
          onCellMouseDown={(e) => onExportChanged(e)}
          onCellClicked={(e) => {
            if (
              e.colDef.headerName === "Actions" ||
              e.colDef.headerName === "" ||
              deletingDocuments.includes(e.data.documentid) ||
              deletingDocuments.includes(e.data.tmfdropzoneid)
            ) {
              return;
            }
            props.documentDetailsHandler(e.data);
          }}
        ></AgGridReact>
      )}
    </div>
  );
};

export default GridContainer;
